import styled from 'styled-components'
import React from 'react'
import { Text, Box, getPaletteColor } from 'pcln-design-system'
import PropTypes from 'prop-types'

const StyledText = styled(Text)`
  font-size: 11px;
  line-height: 14px;
  font-weight: 500;
  color: ${getPaletteColor('secondary.base')};

  ${(props) => props.theme.flyQueries.desktoplg} {
    font-size: 12px;
  }
`
export default function FreeCancellation(props) {
  const { exclamation, message } = props
  const strongText = exclamation ? <strong>{exclamation}</strong> : null

  return message ? (
    <Box data-test='free-cancellation'>
      <StyledText>
        {strongText}
        {strongText ? ' ' : null}
        {message}{' '}
      </StyledText>
    </Box>
  ) : null
}

FreeCancellation.propTypes = {
  exclamation: PropTypes.string,
  message: PropTypes.string.isRequired,
}
